<div class="items-container mb-16" *ngFor="let item of itemsCollection; let index = index; let last = last">
  <div class="d-block w-full">
    <ng-container
      [ngTemplateOutlet]="[childrenTemplates, templates] | findTemplate : itemsTemplateName"
      [ngTemplateOutletContext]="{
        $implicit: { item: item | arrayItemIndex : index : last, control: array.controls[index] }
      }"
    ></ng-container>
  </div>

  <div
    *ngIf="(itemsCollection.length > 1 || !atLeastOneItem) && canRemove"
    class="{{ removeButtonClasses }}"
    (click)="onRemoveItem(index)"
  >
    <ng-container
      *ngIf="
        [childrenTemplates, templates] | findTemplate : removeButtonTemplateName as removeButtonTemplate;
        else standardRemoveButton
      "
    >
      <ng-container [ngTemplateOutlet]="removeButtonTemplate"></ng-container>
    </ng-container>
    <ng-template #standardRemoveButton>
      <button type="button" tabindex="-1" mat-icon-button>
        <mat-icon fontSet="material-symbols-outlined" class="icon-button">delete</mat-icon>
      </button>
    </ng-template>
  </div>
</div>

<div
  *ngIf="canAdd || canAction"
  class="button-wrapper w-full d-flex flex-wrap justify-content-start"
  [class.justify-content-between]="canAdd && actionButtonTemplateName"
  [class.justify-content-end]="actionButtonTemplateName"
>
  <div *ngIf="canAdd" (click)="onAddItem()">
    <ng-container
      *ngIf="
        [childrenTemplates, templates] | findTemplate : addButtonTemplateName as addButtonTemplate;
        else standardAddButton
      "
    >
      <ng-container [ngTemplateOutlet]="addButtonTemplate"></ng-container>
    </ng-container>
    <ng-template #standardAddButton>
      <button type="button" tabindex="-1" mat-raised-button>{{ addButtonCaption }}</button>
    </ng-template>
  </div>

  <div *ngIf="canAction" class="action-button-wrapper">
    <ng-container
      *ngIf="[childrenTemplates, templates] | findTemplate : actionButtonTemplateName as actionButtonTemplate"
    >
      <ng-container [ngTemplateOutlet]="actionButtonTemplate"></ng-container>
    </ng-container>
  </div>
</div>
